import { useState } from 'react';
import { LoginInput } from '@lub0v/santa-utils';
import {
  Button,
  Columns,
  FoldPanel,
  Hint,
  Input,
  OtpInput,
  Specimens,
  Stack,
} from '@src/components';
import { useValidatedForm } from '@src/validation';

function ValidatedSpecimen() {
  const form = useValidatedForm(LoginInput, { email: '', password: '' });

  return (
    <Stack gap={4} wide>
      <Input label="Email" type="email" testId="kit-email" {...form.field('email')} />
      <Input label="Password" password testId="kit-password" {...form.field('password')} />
      <Button variant="secondary" size="small" onClick={() => void form.submit(() => undefined)}>
        Check the form
      </Button>
    </Stack>
  );
}

export function InputSection() {
  const [name, setName] = useState('Santa 28');
  const [budget, setBudget] = useState('0');
  const [password, setPassword] = useState('winter-2026');
  const [search, setSearch] = useState('Maria');
  const [amount, setAmount] = useState('1500');
  const [slug, setSlug] = useState('office-party');
  const [otp, setOtp] = useState('12');

  return (
    <FoldPanel
      id="inputs"
      title="Inputs"
      hint="Label left, error right, hint below. The border and focus glow belong to the field, not the control."
      example={`<Input
  label="Game name"
  value={name}
  onValueChange={setName}
  placeholder="For example, Santa 28"
  hint="Everyone in the game can see this."
/>`}
    >
      <Specimens
        label="States"
        note="Hover and focus each one — the glow turns red while invalid."
      >
        <Columns columns="fill" gap={5}>
          <Input
            label="Game name"
            value={name}
            onValueChange={setName}
            placeholder="For example, Santa 28"
            hint="Everyone in the game can see this."
          />
          <Input
            label="Budget"
            value={budget}
            onValueChange={setBudget}
            numeric
            maxLength={6}
            error="Enter an amount above zero."
          />
          <Input
            label="Disabled"
            value="Locked while the game is archived"
            onValueChange={() => {}}
            disabled
            hint="Archived games are read-only."
          />
        </Columns>
      </Specimens>

      <Specimens label="Affordances" note="Prefix, clear button and password reveal.">
        <Columns columns="fill" gap={5}>
          <Input
            label="Amount"
            value={amount}
            onValueChange={setAmount}
            numeric
            prefix="₽"
            hint="numeric — digits only, and a numeric keypad on mobile."
          />
          <Input
            label="Search"
            value={search}
            onValueChange={setSearch}
            type="search"
            onClear={() => setSearch('')}
            hint="The clear button appears once there is a value."
          />
          <Input
            label="Password"
            value={password}
            onValueChange={setPassword}
            password
            hint="password — reveal toggle included."
          />
        </Columns>
      </Specimens>

      <Specimens
        label="Validated"
        note="useValidatedForm(LoginInput, { email, password }). Blur checks one field; the button checks both. Rules come from @validate on the model — not from the page."
      >
        <ValidatedSpecimen />
      </Specimens>

      <Specimens
        label="One-time code"
        note="Six boxes, one hidden field. A wrong code uses the painted Hint with remaining attempts — not a label-row error."
      >
        <Columns columns="fill" gap={5}>
          <OtpInput label="Six-digit code from the email" value={otp} onValueChange={setOtp} />
          <Stack gap={4} wide>
            <OtpInput
              label="Six-digit code from the email"
              value="12"
              onValueChange={() => {}}
              invalid
            />
            <Hint>That code is incorrect. 2 attempts left.</Hint>
          </Stack>
        </Columns>
      </Specimens>

      <Specimens
        label="Pattern and alignment"
        note="reserveSpace keeps a labelless field level with its neighbours."
      >
        <Columns columns="fill" gap={5}>
          <Input
            label="Invite slug"
            value={slug}
            onValueChange={setSlug}
            pattern={/^[a-z0-9-]*$/}
            hint="Lowercase, digits and dashes — anything else is refused."
          />
          <Input
            value={slug}
            onValueChange={setSlug}
            reserveSpace
            placeholder="No label, still aligned"
          />
        </Columns>
      </Specimens>
    </FoldPanel>
  );
}
